import React from 'react'

const Aside = ({ children, ...rest }) => {
  return <aside {...rest}>{children}</aside>
}

export default Aside
